import { useTranslation } from "react-i18next";
import DragAndDrop from "../components/common/dragAndDrop";
import { useContext, useState } from "react";
import AppContext from "../context/AppContext";
import ApiService from "../api/ApiService";
import notification from "../helpers/notification";
import { ToastContainer } from "react-toastify";
import CalendarComponent from "../components/common/NewCalendarComponent";
import { useNavigate } from "react-router-dom";

export default function MediaPage() {
  const { t } = useTranslation();
  const { user } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [progress, setProgress] = useState(0);
  const [sankirtanDate, setSankirtanDate] = useState("");
  const [comments, setComments] = useState("");
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);
  const navigate = useNavigate();

  const handleCalendarDateSelect = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formatted = `${day}/${month}/${year}`;
    setSankirtanDate(formatted);
  };

  const handleCommentChange = (e) => {
    setComments(e.target.value);
  };

  const handleFileChange = (file) => {
    setUploadedFile(file);
  };

  const handleSubmit = async () => {
    if (!uploadedFile || !sankirtanDate) {
      notification("warning", t("Please provide all required fields."));
      return;
    }

    const isValidDate = /^\d{2}\/\d{2}\/\d{4}$/.test(sankirtanDate);
    if (!isValidDate) {
      notification(
        "warning",
        t("Please enter a valid date in DD/MM/YYYY format.")
      );
      return;
    }

    // Convert DD/MM/YYYY to YYYY-MM-DD for PostgreSQL
    const convertDateDMYtoYMD = (dateStr) => {
      const [day, month, year] = dateStr.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    };

    const formattedDate = convertDateDMYtoYMD(sankirtanDate);

    if (!uploadedFile?.length || !sankirtanDate) {
      notification("warning", t("Please provide all required fields."));
      return;
    }

    const formData = new FormData();
    uploadedFile.forEach((file) => {
      formData.append("files", file); // assuming backend accepts multiple files under 'files'
    });
    formData.append("sankirtan_date", formattedDate);
    formData.append("comments", comments);
    formData.append("user_id", user?.id);
    formData.append("templeName", user?.temple_name);

    setLoading(true);
    setProgress(0);

    try {
      const response = await ApiService.uploadMediaToBackend(formData);
      console.log("respo", response);

      if (response.message === "Media uploaded") {
        notification("success", t("Upload successful!"));
        setUploadedFile([]);
        setSankirtanDate("");
        setComments("");
        setProgress(100);
      } else {
        notification("error", t("Upload failed."));
        setProgress(0);
      }
    } catch (error) {
      console.error(error);
      notification("error", t("Upload failed due to network error."));
    } finally {
      setLoading(false);
    }
  };

  const handleNavigateTransactions = () => {
    setTimeout(() => {
      navigate("/view-history");
    }, 1000);
  };

  return (
    <div className="container common-container pledge-responsive update-responsive">
      <ToastContainer />
      {/* Loader Overlay */}
      {loading && (
        <div className="loader-overlay">
          <div className="loader-container">
            <div className="spinner-border text-primary mb-2" role="status">
              <span className="visually-hidden">{t("Loading...")}</span>
            </div>
            <p className="mb-2">{t("Uploading your sankirtan media...")}</p>
          </div>
        </div>
      )}
      <div className="update-score-container">
        <div className="col-md-12">
          <div className="profile-left">
            <div className="profile-image">
              <div className="">
                <p className="m-0 contact-us-text">
                  {t("Upload Sankirtan Media")}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mt-4">
            <div className="profile-left">
              <div className="col-lg-12">
                <div className="col-lg-12">
                  <label className="label-text mb-1 mt-2 flex items-center">
                    <span className="flex items-center">
                      {t("Upload Images/Videos")}
                      <span style={{ color: "#dc3545", marginLeft: "4px" }}>
                        *
                      </span>
                    </span>
                  </label>
                  <button className="btn-primarysave custom-button" onClick={() => handleNavigateTransactions()} style={{ padding: "10px", marginLeft:"45%" }}>
                    {t("View Historical Media")}
                  </button>
                  <div className="upload-photo mt-2">
                    <DragAndDrop
                      setUploadedFile={setUploadedFile}
                      uploadedFile={uploadedFile}
                    />
                  </div>
                  <p
                    style={{
                      color: "#6E717FE5",
                      marginTop: "2%",
                      fontSize: "14px",
                    }}
                  >
                    {t("You can upload multiple images and videos. Only admin can view these uploads.")}
                  </p>
                </div>

                {/* File upload item with progress */}
                {uploadedFile?.length > 0 &&
                  uploadedFile.map((file, idx) => (
                    <div
                      key={idx}
                      className="border rounded-xl p-2 bg-white shadow-sm mb-2 flex items-center"
                    >
                      <img
                        src="/images/common/jpg.png"
                        alt="jpg"
                        style={{ width: "30px", marginRight: "10px" }}
                      />
                      <div>
                        <p className="text-sm font-medium">{file.name}</p>
                        <p className="text-xs text-gray-500">
                          {(file.size / 1024).toFixed(2)} KB
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div className="col-md-6 mt-4">
            <div
              className="profile-right"
              style={{
                height: "250px", // set your desired fixed height
                overflowY: "auto", // add scrolling if content overflows
                paddingRight: "10px", // optional, to avoid scroll bar overlap
              }}
            >
              <label className="label-text mb-1 mt-2 flex items-center">
                <span className="flex items-center text-[#202124] font-semibold">
                  {t("Date of Sankirtan")}
                  <span style={{ color: "#dc3545", marginLeft: "4px" }}>*</span>
                </span>
              </label>
              <div>
                <input
                  type="text"
                  value={sankirtanDate}
                  readOnly
                  onClick={() => setIsCalendarVisible(true)}
                  placeholder="dd/mm/yyyy"
                  className="w-full p-2 border rounded-lg bg-[#F5F7FA] text-[#43567D] cursor-pointer"
                  style={{
                    borderColor: "#43567D",
                    backgroundColor: "#F8F9FF",
                    borderRadius: "6px",
                    width: "100%",
                  }}
                  required
                />
              </div>

              <label className="label-text mb-1 mt-4 flex items-center">
                <span className="flex items-center text-[#202124] font-semibold">
                  {t("Comments (Optional)")}
                </span>
              </label>
              <div>
                <input
                  type="text"
                  value={comments}
                  onChange={handleCommentChange}
                  placeholder={t("Add comments if any.")}
                  className="w-full p-2 border rounded-lg bg-[#F5F7FA] text-[#43567D] focus:outline-none focus:ring-2 focus:ring-[#43567D]"
                  style={{
                    borderColor: "#43567D",
                    backgroundColor: "#F8F9FF",
                    borderRadius: "6px",
                    width: "100%",
                  }}
                  required
                />
              </div>
              <div className="input-bottom ms-auto load-more-div">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="btn-primarysave custom-button mt-3"
                >
                  {t("Upload Media")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CalendarComponent
        visible={isCalendarVisible}
        onClose={() => setIsCalendarVisible(false)}
        onDateSelect={handleCalendarDateSelect}
        initialDate={
          sankirtanDate
            ? new Date(sankirtanDate.split("/").reverse().join("/"))
            : new Date()
        }
      />
    </div>
  );
}
